jQuery(document).ready(function($) {
    $('.poly-accordion__heading').on('click', function(){
        // $(this).closest('.poly-accordion').find('.poly-accordion__heading').removeClass('active');
        // $(this).closest('.poly-accordion').find('.poly-accordion__content').slideUp();
        $(this).next('.poly-accordion__content').slideToggle();
        $(this).toggleClass('active');
    });

    $('.product-features__btn').on('click', function(){
        $(this).prev('.product-features__more').css('display', 'grid');
        $(this).remove();
    });


    $('.product-gallery').each(function(){
      var $slider = $(this).find('.product-gallery__slider'),
          $next_btn = $(this).find('.slick-arrow__next'),
          $prev_btn = $(this).find('.slick-arrow__prev');

      $slider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: false,       
        prevArrow: $prev_btn,
        nextArrow: $next_btn,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
                breakpoint: 576,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
            }
        ]
      });
    })

    $('.product-accessories').each(function(){
      var $slider = $(this).find('.product-accessories__slider'),
          $next_btn = $(this).find('.slick-arrow__next'),
          $prev_btn = $(this).find('.slick-arrow__prev');
                
      $slider.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: true,
          prevArrow: $prev_btn,
          nextArrow: $next_btn,
          responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                }
              },
              {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  }
              }
          ]
      });
    })
    
});
  